<template lang="pug">
#laudos
    SelecionarTerritorio(
        :tipoLaudo='tipoLaudo',
        @getTerritoriosSelecionados='solicitarLaudos',
        @cancelar-modal='changeShowModalSelecionarTerritorio',
        ref='selecionarTerritorio'
    )
</template>

<script>
import SelecionarTerritorio from '@/components/laudos/SelecionarTerritorio.vue';
import TipoLaudo from '@/constants/TipoLaudo';

import LaudoService from '@/services/LaudosService';

import { mapGetters, mapState } from 'vuex';

export default {
    name: 'Laudos',

    components: {
        SelecionarTerritorio
    },

    computed: {
        ...mapGetters(['usuarioLogado']),
        ...mapState(['usuarioIsLaudo'])
    },

    data() {
        return {
            tipoLaudo: TipoLaudo.TECNICO_AGRICOLA,
            showModalVisualizacao: false,
            showModalSelecionarTerritorios: false,
            idLaudo: null,
            laudos: [],
            pageParams: {
                page: 1,
                size: 20,
                sort: 'dataCadastro,DESC'
            },
            filtros: {
                dataCadastroFim: '',
                dataCadastroInicio: '',
                dataFinalizacaoFim: '',
                dataFinalizacaoInicio: '',
                representantesCpfCnpj: [],
                situacaoId: '',
                statusId: '',
                territoriosIds: [],
                tipoLaudoId: TipoLaudo.TECNICO_AGRICOLA
            },
            showModalInsercaoResultados: false,
            rowInfo: null,
            totalLaudos: 0,
            usuariosBuffer: {},
            loading: false,
            isLaudoUnico: false
        };
    },

    async mounted() {
        if (this.usuarioIsLaudo) {
            this.$router.push({ name: 'LaudoAvaliacaoSocioambiental' });
        }
        await this.getLaudos();
    },

    methods: {
        async getLaudos() {
            await this.requestLaudos();
        },

        changeShowModalSelecionarTerritorio() {
            this.showModalSelecionarTerritorios =
                !this.showModalSelecionarTerritorios;
            this.$emit('showModalSelecionarTerritorios');
        },

        solicitarLaudos(idsTerritoriosSelecionados) {
            let idsTerritorio = '';
            idsTerritoriosSelecionados.forEach(territorio => {
                idsTerritorio += territorio.id + '-';
            });
            this.$router.push({
                name: 'LaudoSolicitacaoTecnicoAgricola',
                params: { idsTerritorio }
            });
        },

        async requestLaudos() {
            try {
                this.loading = true;
                const { data } = await LaudoService.requestLaudos(
                    this.filtros,
                    this.pageParams
                );
                this.totalLaudos = data.totalItens;
                this.laudos = data.laudos;
            } catch (error) {
                this.$notify.error({
                    message: this.$t('mensagens.laudos.erro.naoFoiPossivelCarregarOsDados')
                });
            } finally {
                this.loading = false;
            }
        },

        abrirModalVisualizacao(laudo) {
            this.showModalVisualizacao = !this.showModalVisualizacao;
            this.idLaudo = laudo;
        },

        ordenar(paramsProp) {
            this.pageParams = {
                page: this.pageParams.page,
                size: 20,
                sort: `${paramsProp.column},${paramsProp.order}`
            };
            this.getLaudos();
        },

        filtrar(filtros) {
            this.filtros = { ...filtros };
            this.getLaudos();
        },

        abrirModalInsercaoResultados(rowInfo) {
            this.rowInfo = rowInfo;
            this.alterarExibicaoModalInsercaoResultados(true);
        },

        alterarExibicaoModalInsercaoResultados(mostrar) {
            this.showModalInsercaoResultados = mostrar;
        },

        atualizaLaudoUnico(laudoUnico) {
            this.isLaudoUnico = laudoUnico === 'true';
        }
    }
};
</script>

<style scoped lang="scss">
#laudos {
    .laudo-margin {
        margin-bottom: 20px;
    }

    .selecionados,
    .nao-selecionados {
        display: flex;
        flex-direction: column;

        .el-checkbox {
            width: 100%;
            display: flex;
            align-items: center;

            .el-checkbox__label {
                display: flex;
                flex-direction: column;

                p {
                    line-height: 16px;
                }
            }

            em {
                font-weight: 200;
                font-size: 12px;
            }
        }
    }

    .lista {
        background: var(--white);
        border-radius: 4px;
        overflow: hidden;
    }

    header {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
}
</style>
